import React, { useEffect, useState } from "react";
import { Select, Input } from "antd";
import { api, notification } from "../../services";
import { AutoResizeTextArea } from "../AutoResizeTextArea";
import styles from "./contactButton.scss"
import { Button } from "../Button/Button";

const { Option } = Select;

export const ReportTypesValues = {
  problemReport: 1,
  improvementReport: 2,
  rest: 3
}


export const ReportTypesLabels = {
  [ReportTypesValues.problemReport]: "Prijava problema",
  [ReportTypesValues.improvementReport]: "Prijedlog za poboljšanje",
  [ReportTypesValues.rest]: "Ostalo"
}

const ProblemReportValues = {
  paymentAndPromotions: 1,
  technicalIssues: 2,
  userAccountIssues: 3,
  adIssues: 4,
  searchIssues: 5,
  scamReport: 6,
  other: 7
}

export const ProblemReportLabels = {
  [ProblemReportValues.paymentAndPromotions]: "Uplate i promocije",
  [ProblemReportValues.technicalIssues]: "Tehnički problemi",
  [ProblemReportValues.userAccountIssues]: "Problem s korisničkim računom",
  [ProblemReportValues.adIssues]: "Problem s oglasom",
  [ProblemReportValues.searchIssues]: "Problemi s pretraživanjem",
  [ProblemReportValues.scamReport]: "Prijava pokušaja prijevare",
  [ProblemReportValues.other]: "Ostalo",
}


export const SUBCATEGORIES = {
  [ReportTypesValues.problemReport]: [
    ProblemReportValues.paymentAndPromotions,
    ProblemReportValues.technicalIssues,
    ProblemReportValues.userAccountIssues,
    ProblemReportValues.adIssues,
    ProblemReportValues.searchIssues,
    ProblemReportValues.scamReport,
    ProblemReportValues.other,
  ],
};

const emailRegex = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/gi;

export const FeedbackForm = ({ email, onClose, isFeedbackModalVisible }: { email?: string; onClose: () => void; isFeedbackModalVisible: boolean }) => {
  const [category, setCategory] = useState(undefined);
  const [subcategory, setSubcategory] = useState(undefined);
  const [text, setText] = useState("");
  const [emailInputValue, setEmailInputValue] = useState(email || "");
  const [submitting, setSubmitting] = useState(false);


  const resetForm = () => {
    setCategory(undefined);
    setSubcategory(undefined)
    setText("")
    setEmailInputValue(email || "")
  }

  useEffect(() => {
    if (!isFeedbackModalVisible) {
      resetForm()
    }
  }, [isFeedbackModalVisible])

  const handleSubmit = async () => {

    if (isSubmitDisabled) return;

    setSubmitting(true);
    try {
      await api.UserFeedback.postUserFeedback({
        group: category,
        subGroup: subcategory,
        text,
        email: email || emailInputValue,
      });

      notification.show("Hvala! Zaprimili smo vašu poruku i javit ćemo vam se u najkraćem roku.")
      setSubmitting(false);
      onClose();
      resetForm()

    } catch (error) {
      notification.showError("Greška pri slanju poruke");
      setSubmitting(false);

    }
  };

  const handleSubmitForm = (e: React.FormEvent) => {
    e.preventDefault();
    handleSubmit();
  };

  const subcategories = category ? SUBCATEGORIES[category] : undefined;
  const showSubcategorySelect = !!subcategories;
  const showTextField = [ReportTypesValues.rest, ReportTypesValues.improvementReport].includes(category) || subcategory !== undefined;

  const isSubcategoryValid = !showSubcategorySelect || subcategory !== undefined;
  const shouldShowEmail = !email && showTextField

  const isEmailValid = shouldShowEmail ? emailInputValue.match(emailRegex) : true;
  const isFormValid = category !== undefined && isSubcategoryValid && showTextField && text.length >= 1 && isEmailValid;

  const isSubmitDisabled = submitting || !isFormValid || text.length < 20;




  return (
    <form onSubmit={handleSubmitForm}>
      <p style={{ marginBottom: 10 }}>Vaša povratna informacija pomaže nam da unaprijedimo Index Oglase.</p>
      <span className={styles.label}>Što želite prijaviti?</span>
      <Select
        style={{ width: "100%", marginBottom: 16 }}
        placeholder="Odaberi..."
        getPopupContainer={(trigger: any) => trigger.parentNode}
        value={category}
        onChange={(val) => {
          setCategory(val);
          setSubcategory(undefined);
        }}
      >
        <Option value={ReportTypesValues.problemReport}>{ReportTypesLabels[ReportTypesValues.problemReport]}</Option>
        <Option value={ReportTypesValues.improvementReport}>{ReportTypesLabels[ReportTypesValues.improvementReport]}</Option>
        <Option value={ReportTypesValues.rest}>{ReportTypesLabels[ReportTypesValues.rest]}</Option>
      </Select>
      {showSubcategorySelect && (
        <React.Fragment>
          <span className={styles.label}>Na što se odnosi?</span>

          <Select
            style={{ width: "100%", marginBottom: 16 }}
            placeholder="Odaberi..."
            getPopupContainer={(trigger: any) => trigger.parentNode}
            value={subcategory}
            onChange={(val) => {
              setSubcategory(val);
              setText("");
            }}
          >
            {subcategories.map((sub) => (
              <Option key={sub} value={sub}>{ProblemReportLabels[sub]}</Option>
            ))}
          </Select>
        </React.Fragment>
      )}
      {shouldShowEmail && (
        <React.Fragment>
          <span className={styles.label}>E-mail</span>
          <Input
            placeholder="Upiši e-mail..."
            value={emailInputValue}
            onChange={e => setEmailInputValue(e.target.value)}
            autoFocus
            style={{ marginBottom: 16 }}
          />
        </React.Fragment>
      )}
      {showTextField && (
        <React.Fragment>
          <span className={styles.label}>Opišite ukratko (minimalno 20 znakova)</span>

          <AutoResizeTextArea
            style={{
              width: "100%",
              minHeight: 100,
              padding: 8,
              borderRadius: 4,
              border: "1px solid #d9d9d9",
              boxSizing: "border-box",
              marginBottom: 16,
            }}
            autoFocus={!shouldShowEmail}
            placeholder=" Npr. što se dogodilo ili što biste željeli poboljšati"
            value={text}
            onChange={(e) => setText(e.target.value)}
          />
        </React.Fragment>
      )}
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          htmlType="submit"
          type="primary"
          disabled={isSubmitDisabled}
          loading={submitting}
          size="large"
          style={{ fontWeight: 700, textTransform: "capitalize" }}
        >
          Pošalji
        </Button>
      </div>
    </form>
  );
}



// WEBPACK FOOTER //
// ./src/components/ContactButton/FeedbackForm.tsx